require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-deutsch-schuetzen-eisenberg.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-deutsch-schuetzen-eisenberg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-deutsch-schuetzen-eisenberg!./.cache/json/betreuungseinrichtungen-oberwart-deutsch-schuetzen-eisenberg.json
// module id = 1003
// module chunks = 231608221292675